import styled from '@emotion/styled';
import React from 'react';
import Link from 'next/link';
import Colors from '../../styles/Colors';
import Text, { TextTypesEnum } from '../../elements/Text';
import Icon from '../../elements/Icon';
import Icons from '../../elements/Icons';
import { useAppDispatch } from '../../redux/store';
import { AppActions } from '../../redux/app.redux';

const OSNoticeOuterModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: white;
  max-width: 800px;
  border-radius: 4px;
  gap: 16px;
`;
const OSNoticeTopHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 8px 24px;
`;
const OSNoticeTopHeaderTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items:  center;
  padding: 8px 24px;
`;
const OSNoticeTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;
const OSTopBodyTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 690px;
`;
const OSLowerBodyTextContainer = styled(OSTopBodyTextContainer)``;
const OSNoticeLearnMoreButton = styled.div`
  display: flex;
  padding: 8px 12px;
  background-color: ${Colors.Blurple50};
  max-width: 385px;
  border-radius: 4px;
  margin: 16px 0px;
`;
const OSGetStartedWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${Colors.Blurple700};
  padding: 16px 0;
  border-radius: 0 0 4px 4px;
  width: 100%;
`;

/** Interface */
export interface OfficeSpaceNoticeProps {}

const OfficeSpaceNoticeSRPModal: React.FC = () => {
  /** Redux State */
  const dispatch = useAppDispatch();
  const popModal = () => dispatch(
    AppActions.popModal(),
  );

  /** Render */
  return (
    <OSNoticeOuterModalContainer>
      <OSNoticeTopHeaderContainer>
        <OSNoticeTopHeaderTextContainer>
          <Text
            type={TextTypesEnum.Bold18}
          >
            Important Notice
          </Text>
          <Text type={TextTypesEnum.Bold24}>The Biproxi marketplace is moving to OfficeSpace.com</Text>
        </OSNoticeTopHeaderTextContainer>
        <Icon
          icon={Icons.TimesRegular}
          size={24}
          onClick={popModal}
        />
      </OSNoticeTopHeaderContainer>

      <OSNoticeTextContainer>
        <OSTopBodyTextContainer>
          <Text type={TextTypesEnum.Regular18}>
            Biproxi users can create a free account on OfficeSpace.com to start buying, selling, or leasing commercial real estate.
            You must create a new account, your Biproxi account will not be automatically transferred. Effective 7/1/2023 the Biproxi marketplace
            will be fully transitioned over to OfficeSpace.com. All listing information, documents, etc. will be removed and no longer accessible after this date.
          </Text>
        </OSTopBodyTextContainer>
        <OSLowerBodyTextContainer>
          <Text type={TextTypesEnum.Regular18}>
            <b>Questions about the transition to OfficeSpace.com?</b>
            <br />
            We’re here to help you get the most out of the new marketplace experience on OfficeSpace.com.
            <br />
            If you have questions about your Biproxi account or getting started with OfficeSpace.com, please email:
            {' '}
            <span style={{ color: Colors.Blurple600 }}>casey@officespace.com</span>
            .
          </Text>
        </OSLowerBodyTextContainer>
      </OSNoticeTextContainer>

      <OSNoticeLearnMoreButton>
        <Link href="https://www.officespace.com/pages/biproxi-marketplace" target="_blank">
          <Text
            type={TextTypesEnum.Bold14}
            color={Colors.Blurple700}
          >
            Learn more about the transition to OfficeSpace.com
          </Text>
        </Link>
      </OSNoticeLearnMoreButton>

      <OSGetStartedWrapper>
        <Link href="https://www.officespace.com/users/sign_up?style=inline&original_protocol=https" target="_blank">
          <Text type={TextTypesEnum.Bold18} color={Colors.White}>
            Get started for free
          </Text>
        </Link>
      </OSGetStartedWrapper>
    </OSNoticeOuterModalContainer>
  );
};

export default OfficeSpaceNoticeSRPModal;
